// TODO - Documentar
import { useEffect, useState } from 'react'
import { useDispatch } from "react-redux";

// Global constants
import * as con from "../../GlobalConstants"
import { RefMarketValueHook, RefSPOT } from '../hooks/MarketValuesHook';
import NumberFormat from 'react-number-format'

import "./Spot.css"
import { parseMoney } from '../../utils/moneyFunctions'
import { Button, Checkbox } from '@blueprintjs/core'
import { setMarketValue, updateSpot } from '../../store/slices/marketValuesSlice';

function SimpleSpot() {
    // Current SPOT and Spot scheme 
    const dispatch = useDispatch();       
    const spot = RefSPOT()
    const spotScheme = RefMarketValueHook(con.SPOT_SCHEME)
    const spotDirection = RefMarketValueHook(con.SPOT_DIRECTION)
    const lasUpdated = RefMarketValueHook(con.LAST_SPOT_UPDATE)

    const [justUpdated, setJustUpdated] = useState(false)

    const toggleSpotScheme = () => {
        if(spotScheme === con.MANUAL) {
            dispatch(updateSpot())
            dispatch(setMarketValue({id: con.SPOT_SCHEME, value: con.AUTOMATIC}))
        }
        else
            dispatch(setMarketValue({id: con.SPOT_SCHEME, value: con.MANUAL}))
    }

    useEffect(() => {
        const handleKeyPress = (e) => {
            if (e.key === "F9") {
                dispatch(updateSpot())

            }
        }
        window.addEventListener("keydown", handleKeyPress)
        return () => {
            window.removeEventListener("keydown", handleKeyPress)
        }
    }, [dispatch])

    useEffect(() => {
        setJustUpdated(true)
        setTimeout(() => {setJustUpdated(false)}, con.VALUE_CHANGE_TIMEOUT)
    }, [lasUpdated])

    if (spotScheme === con.AUTOMATIC) {
        return (
            <div className="spot-container" style={{
                display: "flex",
                alignItems: "center",
                color: justUpdated
                    ? spotDirection === con.NEUTRAL
                        ? "blue"
                        : spotDirection === con.UP
                            ? "green"
                            : "red"
                    : "var(--text-color-highlighted)"
            }}>
                <Button text="SPOT" icon="refresh" onClick={(e) => dispatch(updateSpot())} />
                <span style={{margin: "0 10px"}}>{spot}</span>
                <Checkbox label="Manual" style={{margin:"0"}} onChange={() => toggleSpotScheme()}/>
            </div>
        )
    } else {
        return (
            <div className="spot-container" style={{display:"flex", alignItems:"center"}}>
                <span style={{marginTop:"10px"}}> Spot Manual: </span>
                <NumberFormat thousandSeparator={true} 
                    className="input-editing spot-input"
                    onFocus={e => e.target.select()} 
                    onClick={e => e.target.select()} 
                    onBlur={(e) => {
                        let value;

                        if (e.target.value === "") {
                            value = spot;
                        } else {
                            value = parseMoney(e.target.value);
                        }

                        dispatch(setMarketValue({
                            id: con.SPOT,
                            value
                        }));
                    }}
                    value={spot}
                    style={{margin: "0 10px"}}/>
                <Checkbox label="Manual" style={{margin:"0"}} onChange={() => toggleSpotScheme()}/>
            </div>
        )
    }
}

export default SimpleSpot